import { TENANTS_LOADING, SET_TENANTS, TENANT_LOAD_ERROR } from "../constants";
import { Tenant } from "../../types/tenant";

const initial_state = {
  loading: false,
  error: null,
  list: [] as Tenant[],
};

interface stateOptions {
  type: string;
  payload?: any;
  error?: any;
}

export default function UserReducer(state = initial_state, { type, payload }: stateOptions) {
  switch (type) {
    case TENANTS_LOADING:
      return {
        ...state,
        loading: true,
      };

    case SET_TENANTS:
      return {
        ...state,
        loading: false,
        error: null,
        list: payload,
      };

    case TENANT_LOAD_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
        list: [],
      };

    default:
      return state;
  }
}
